<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
<div class="grey-page">
	<section class="container">
		<h2 class="page__main-title"><span class="mq-sm-hide">Dashboard</span></h2>
    <!-- booking.pending -->
    <h3>Viewings</h3>
    <p v-if="bookingsPending.length">
      <span style="color: orange;font-weight:bold">Requested</span>
      <div v-for="(booking, index) in bookingsPending">
        <booking-box class="booking-event-box" :key="booking.trackId" :booking="booking" :isPending="true" :color="'orange'" :arrayIndex="index"></booking-box>
      </div>
    </p>

    <p v-if="bookingsConfirmed.length">
      <span style="color: green;font-weight:bold">Booked</span>
      <div v-for="(booking, index) in bookingsConfirmed">
        <booking-box class="booking-event-box" :key="booking.trackId" :booking="booking" :arrayIndex="index" :color="'green'"></booking-box>
        <!--
        <a :href="'/properties/'+booking.propertyId">{{ booking.property.address.buildingNumber }} {{ booking.property.address.street }} {{ booking.property.address.town }}</a>, {{ niceDate(booking.date_suggested) }},
        <a v-if="booking.profileExtra.applicantId" :href="'/applicants/'+booking.profileExtra.applicantId">{{ booking.profileExtra.name }}</a>
        <span v-else>{{ booking.profileExtra.name }}</span>
      -->
      </div>
    </p>

    <p v-if="bookingsCancelled.length">
      <span style="color: red;font-weight:bold">Cancelled</span>
      <div v-for="(booking, index) in bookingsCancelled">
        <booking-box class="booking-event-box" :key="booking.trackId" :booking="booking" :arrayIndex="index" :color="'red'"></booking-box>
      </div>
    </p>

    <p v-if="bookingsPast.length">
      <span style="font-weight:bold">Completed Viewings</span>
      <div v-for="(booking, index) in bookingsPast">
        <booking-box class="booking-event-box" :key="booking.trackId" :booking="booking" :arrayIndex="index" :color="'black'"></booking-box>
      </div>
    </p>

    <h3>Properties</h3>
		<div v-for="(property, index) in propertiesReversed">
			<!-- NEW PROPERTY -->
			<event-box :key="property.propertyId" :property="property" :arrayIndex="index"></event-box>
		</div>

	    <!-- <div v-for="event in eventsReversed">
	        <applicant-box v-if="event.typeId == eventTypes.CREATE_APPLICANT" :applicant="event.obj" :propertyTypes="propertyTypes" :showDismiss="true" :dismissId="event.id"></applicant-box>

	        <applicant-box v-if="event.typeId == eventTypes.APPLICANT_MATCHED_TO_PROPERTIES" :applicant="event.obj" :propertyTypes="propertyTypes" :isMatch="true" :matches="event.matches" :showDismiss="true" :dismissId="event.id"></applicant-box>

	        <property-box v-if="event.typeId == eventTypes.CREATE_PROPERTY" :property="event.obj" :propertyTypes="propertyTypes" :propertySubtypes="propertySubtypes" :propertyStatus="propertyStatus" :showDismiss="true" :dismissId="event.id"></property-box>

	        <property-box v-if="event.typeId == eventTypes.PROPERTY_MATCHED_TO_APPLICANTS" :property="event.obj" :propertyTypes="propertyTypes" :propertySubtypes="propertySubtypes" :propertyStatus="propertyStatus" :showDismiss="true" :dismissId="event.id" :isMatch="true" :matches="event.matches"></property-box>
	    </div> -->
	</section>
	<!-- Add Property Button -->
	<figure class="btn-add-property--fixed">
		<button class="mdc-fab material-icons mdc-ripple-upgraded" type="button" aria-label="addProperty" @click.prevent="$router.push('/properties/add')"><i class="ico-icons8-plus_math mdc-fab__icon"></i></button>
	</figure>
</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import EventBox from '../components/EventBox.vue';
import BookingBox from '../components/BookingBox.vue';
import ButtonWithSpinner  from '../components/ButtonWithSpinner.vue';

export default {
    data: function() {
        return {
              isSaving: false,
			       properties: [],
             bookingsPending: [],
             bookingsConfirmed: [],
             bookingsCancelled: [],
             bookingsPast: []
        }
    },
    components: {
        'event-box': EventBox,
        'booking-box': BookingBox,
        'button-with-spinner': ButtonWithSpinner
    },
    created: async function() {
  		this.properties = await api({endpoint: this.config.services.properties, path: '/', method: 'GET'});
  		if(this.properties.length == 0) {
  			window.location = '/start';
  		}
      const bookings = await api({endpoint: this.config.services.booking, path: '/list', method: 'GET'});
      await this.sortBooking(bookings)
    },
    computed: {
		  propertiesReversed: function() {
			  return this.properties.reverse();
		  }
    },
    methods: {
      bookReopen: function(trackId,myId){
        window.location.pathname = `/booking/${trackId}/${myId}/reopen`;
      },
      confirmPending: function(trackId,myId){
        window.location.pathname = `/booking/${trackId}/${myId}/confirm`;
      },
      bookCancel: function(trackId,myId){
        window.location.pathname = `/booking/${trackId}/${myId}/cancel`;
      },
      suggestPending: function(trackId,myId){
        window.location.pathname = `/booking/${trackId}/${myId}/newsuggest`;
      },
      sortBooking: async function(bookings) {
        this.bookingsPending = [];
        this.bookingsConfirmed = [];
        this.bookingsCancelled = [];
        this.bookingsPast = [];

        await Promise.all(bookings.map(b => {
          // all trash not to be listed
          if (
            b.status == 'missingprop'
            || (b.nextaction != 'inviter' && b.status == 'pending' && b.phase == 'invitation')
            || (b.nextaction != 'inviter' && b.status == 'pending' && b.phase == 'schedule')
          ) {

          // everything serious, or not
          } else if (b.phase != 'closed' && (b.status == 'pending' || b.status == 'suggested')) {
            this.bookingsPending.push(b);
          } else if (b.phase == 'confirmation' && (b.status == 'confirmed' || b.status == 'accepted') && (new Date().getTime()) <= (b.date_suggested)) {
            this.bookingsConfirmed.push(b);
          } else if (b.status == 'cancelled') {
            this.bookingsCancelled.push(b);
          } else if (b.phase == 'confirmation' && (b.status == 'confirmed' || b.status == 'accepted') && (new Date().getTime()) >= (b.date_suggested)) {
            this.bookingsPast.push(b);
          }
        }));
		  },
      niceDate(datetime,nohours,withminutes) {
        var notnow = new Date(datetime);
        var now = new Date();
        var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
        var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','October','Nov','Dec'];

        var day = days[ notnow.getDay() ];
        var month = months[ notnow.getMonth() ];

        var date = notnow.getDate();
        var hours = notnow.getHours();
        var ampm = hours >= 12 ? ' pm' : ' am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        var dateString = '';
        if (notnow.getDay() == now.getDay() && notnow.getMonth() == notnow.getMonth() && notnow.getFullYear() == notnow.getFullYear()) {
          dateString += "Today";
        }
        else if (notnow.getDay() == (now.getDay()+1) && notnow.getMonth() == notnow.getMonth() && notnow.getFullYear() == notnow.getFullYear()) {
          dateString += "Tomorrow";
        } else {
          dateString += day+" " +date;
          dateString += (now.getMonth() == notnow.getMonth()) ? '' : ', '+month;
        }
        if (!nohours) {
          dateString += " "+hours;
          if (parseInt(notnow.getMinutes()) != 0)
            dateString += ":"+notnow.getMinutes();
          dateString += " "+ampm;
        }

        return dateString;
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue